import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/StationLocationMaps/Get`, payload),
    GetStations: (payload) => Repository.post(`/api/StationLocationMaps/GetStations`, payload),
    GetLives: (payload) => Repository.post(`/api/StationLocationMaps/GetLives`, payload),
    Add: (payload) => Repository.post(`/api/StationLocationMaps/Add`, payload),
    Delete: (payload) => Repository.post(`/api/StationLocationMaps/Delete`, payload),
}
